import HowWeWork from "./howWeWork";
import PartneringWithSeveralBrands from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands";
import CostPerCallIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerCallIcon";
import CostPerClickIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerClickIcon";
import CostPerLeadIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerLeadIcon";
import CostPerRetainerIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerRetainerIcon";
import CostPerSaleIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerSaleIcon";
import RevenueShareIcon from "@components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/revenueShareIcon";
import { ReactNode } from "react";
export type HowWeHelpList = { title: string; p: string; icon: ReactNode }[];
const list = [
    {
        title: "Cost Per Click",
        p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
        icon: <CostPerClickIcon />,
    },
    {
        title: "Cost Per Sale",
        p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
        icon: <CostPerSaleIcon />,
    },
    {
        title: "Cost Per Lead",
        p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
        icon: <CostPerLeadIcon />,
    },
    {
        title: "Cost Per Call",
        p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
        icon: <CostPerCallIcon />,
    },
    {
        title: "Performance-Based Cost Structure",
        p: "Law firms can benefit from a risk-free partnership with us. Our payment is contingent upon the signing of the retainer, either managed by your intake team or our dependable intake center.",
        icon: <CostPerRetainerIcon />,
    },
    {
        title: "Revenue Share",
        p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
        icon: <RevenueShareIcon />,
    },
];
export default function GeneralCategoryThirdSection({
    mainData,
}: {
    mainData?: {
        howWeHelpContent?: {
            list?: HowWeHelpList;
            mainTitle?: string;
            benefitListClassName?: string;
            benefitItemClassName?: string;
        };
        howWeWorkContent?: {
            list: { description: string; title?: string }[];
            title: string;
        };
        hideHowWeWorkContent?: boolean;
    };
}) {
    return (
        <section>
            <HowWeWork
                mainData={{
                    list: mainData?.howWeWorkContent?.list,
                    title: mainData?.howWeWorkContent?.title,
                }}
            />

            {!mainData?.hideHowWeWorkContent && (
                <div className="mb-32">
                    <PartneringWithSeveralBrands
                        list={
                            (mainData?.howWeHelpContent?.list
                                ? mainData?.howWeHelpContent?.list
                                : list) as HowWeHelpList
                        }
                        mainTitle={
                            mainData?.howWeHelpContent?.mainTitle
                                ? mainData?.howWeHelpContent?.mainTitle
                                : "How We Help Your Business Attract More Customers"
                        }
                        benefitListClassName={
                            mainData?.howWeHelpContent?.benefitListClassName
                        }
                        benefitItemClassName={
                            mainData?.howWeHelpContent?.benefitItemClassName
                        }
                    />
                </div>
            )}
        </section>
    );
}
